import { Box, Button, MenuItem, Select, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ModalWrapper } from 'src/components'
import { useStyles } from './../styles'

import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { IChallengesBaseWithId, IItemsRemoveConfirmModalValues } from 'src/types'
import { useGetActiveChallanges } from 'src/hooks/challenges/use-get-active-challanges.hook'

interface IProps {
  open: boolean
  handleClose: () => void
  handleConfirmApprove: (challange: string | null) => void
  confirmModalHandler: Dispatch<SetStateAction<IItemsRemoveConfirmModalValues | null>>
}

export const SelectChallengeModal = ({
  open,
  handleClose,
  handleConfirmApprove,
  confirmModalHandler,
}: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  const [challange, setChallange] = useState<IChallengesBaseWithId | null>(null)

  const { data, isLoading } = useGetActiveChallanges(open)

  useEffect(() => {
    setChallange(null)
  }, [open])

  const handleChallangeSelect = (challange: string) => {
    if (!data) {
      return
    }

    const id = challange

    if (id === '') {
      setChallange(null)
    } else {
      const item = data.find((item) => item.id === id)
      setChallange(item || null)
    }
  }

  const handleScanApprovalConfirm = async () => {
    confirmModalHandler({
      handleConfirm: async () => {
        handleConfirmApprove(challange?.id || null)
      },
      customModal: {
        title: 'Confirm Approval',
        secondaryText:
          'If Challenge is selected, only pending scans that belong to it will be approved; otherwise, approve ALL pending scans',
      },
      itemsTitles: [],
      itemsDetails: [{ text: challange?.name || 'All', title: 'Selected' }],
      itemsRelations: [],
      itemsType: '',
    })
  }

  return (
    <ModalWrapper
      open={open}
      onClose={() => {
        setChallange(null)
        handleClose()
      }}
      className={classes.reasonModal}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          gap: '12px',
        }}
      >
        <Typography
          sx={{
            color: theme.palette.custom.darkBlue2,
            fontSize: '18px',
            fontWeight: 600,
            width: '100%',
          }}
        >
          Select challenge:
        </Typography>

        {!!data && (
          <Select
            name="type"
            value={challange?.id || ''}
            onChange={(e) => handleChallangeSelect(e.target.value)}
            size="small"
            autoWidth
            MenuProps={{ style: { maxHeight: '400px' } }}
            sx={{
              fontSize: '12px',
            }}
            displayEmpty
            renderValue={(selected) =>
              selected === '' ? 'All' : data.find((item) => item.id === selected)?.name
            }
          >
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            {data.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        )}

        <Box>
          <Typography
            sx={{
              color: theme.palette.custom.darkBlue2,
              fontSize: '14px',
              width: '100%',
              fontWeight: 600,
            }}
          >
            Description:
          </Typography>
          {challange && (
            <Typography
              sx={{
                color: theme.palette.custom.darkBlue2,
                fontSize: '14px',
                width: '100%',
              }}
            >
              {challange.description}
            </Typography>
          )}
        </Box>
      </Box>
      <Box sx={{ width: '100%', textAlign: 'center', pt: '10px' }}>
        <Button
          disabled={isLoading}
          onClick={() => {
            handleScanApprovalConfirm()
            handleClose()
          }}
          variant="contained"
          size="small"
        >
          Confirm
        </Button>
      </Box>
    </ModalWrapper>
  )
}
